export default () => ({
  open: false,

  init() {
    if (this.$el.dataset.teleport === "true") {
      this.$nextTick(() => this.$dialogTeleport(this.$refs.menu));
    }

    this.$watch("open", (value: boolean) => this.showInTopLayer(value));
  },

  /**
   * Shows or hides the menu in the top layer, so that it draws over the rest
   * of the page and is not cut off by its container. Browsers without
   * togglePopover() keep the earlier behavior.
   */
  showInTopLayer(show: boolean): void {
    const menu = this.$refs.menu as
      | (HTMLElement & {
          togglePopover?: (options: { force: boolean }) => void;
        })
      | undefined;

    if (!menu?.isConnected) return;

    // Unhide first, or the browser ignores the call and the menu flashes
    if (show) menu.style.removeProperty("display");

    menu.togglePopover?.({ force: show });
  },
});
